export default {"src":"/_next/static/media/raised.0f5eb27d.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};